import React from 'react'
import Drawer from '@material-ui/core/Drawer'
import { makeStyles } from '@material-ui/core/styles'
import withWidth, { isWidthDown, WithWidthProps } from '@material-ui/core/withWidth'
import { useLocation } from 'react-router-dom'
import { useEffectOnce } from 'react-use'
import { Routes } from '../../../consts'
import { useLoading } from '../../atoms/Loading'
import Header from './Header'
import Sider from './Sider'

const drawerWidth = 240

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex'
    // minWidth: Layouts.MinMainContentWidth
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0
  },
  drawerPaper: {
    // minHeight
    // height: 'auto',
    // overflow: 'scroll',
    width: drawerWidth
  },
  toolbar: theme.mixins.toolbar,
  content: {
    width: '100%',
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3)
  }
}))

const Component: React.FC<WithWidthProps> = ({ width, children }) => {
  const classes = useStyles()
  const location = useLocation()
  const isSiderHide = location.pathname === Routes.Search.path || (width && isWidthDown('sm', width))
  const [openSider, setOpenSider] = React.useState(false)

  const { handleIsLoading } = useLoading()
  useEffectOnce(() => {
    // ダッシュボードを表示したらローディングを止める
    handleIsLoading(false)
  })

  // 遷移の度にスクロールをトップに戻す
  const [currentPathname, setCurrentPathname] = React.useState<string>('')
  React.useEffect(() => {
    // ロケーションが違う時のみスクロールする
    if (currentPathname !== location.pathname) {
      try {
        window.scrollTo(0, 0)
      } catch (error) {
        console.error('scroll can not work in your browser')
      }
    }
    setCurrentPathname(location.pathname)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  return (
    <>
      <div className={classes.root}>
        <Header openSider={openSider} setOpenSider={setOpenSider} />
        <Drawer
          className={classes.drawer}
          classes={{
            paper: classes.drawerPaper
          }}
          variant={isSiderHide ? 'temporary' : 'permanent'}
          open={openSider}
          onClose={() => {
            setOpenSider(false)
          }}
          anchor="left"
        >
          <Sider openSider={openSider} setOpenSider={setOpenSider} />
        </Drawer>
        <main className={classes.content}>
          <div className={classes.toolbar} />
          {children}
        </main>
      </div>
    </>
  )
}

export default withWidth()(Component)
